import { CONTACT_NUMBER_REGEX } from '../regex.mjs';

function formatContactNumber(value) {
  const executed = CONTACT_NUMBER_REGEX.exec(value);
  if (executed != null) {
    if (executed[4] != null) {
      return [executed[5], executed[6], executed[7], executed[8]].filter((match) => match != null && match !== "").join("-");
    }
    if (executed[9] != null) {
      return [executed[9], executed[10], executed[11]].filter((match) => match != null && match !== "").join("-");
    }
    if (executed[12] != null) {
      return [executed[12], executed[13], executed[14]].filter((match) => match != null && match !== "").join("-");
    }
    const first = executed[1] || "";
    const second = executed[2] != null ? `-${executed[2]}` : "";
    const third = executed[3] != null ? `-${executed[3]}` : "";
    return `${first}${second}${third}`;
  }
  return value;
}

export { formatContactNumber };
//# sourceMappingURL=formatContactNumber.mjs.map
